import get from "lodash.get";
import { Popover } from "react-bootstrap";
import styled from "styled-components";
import { headerHeight } from "../navigator.constants";

export const PopoverStyled = styled(Popover)`
  border: none;
  z-index: 100001;
  min-width: 220px;
  max-width: max-content;
  width: fit-content;
  box-shadow: rgba(24, 39, 75, 0.12) 0px 8px 28px -6px,
    rgba(24, 39, 75, 0.14) 0px 18px 88px -4px;
  padding: 10px;
  border-radius: 8px;

  .multiPoppoverContents {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .poppoverHeader {
    font-size: 13px !important;
    color: #999 !important;
    background-color: transparent !important;
    border-bottom: 1px solid #f3f3f3;
  }

  .selected-menu {
    color: ${({ theme }) => get(theme, "primary.dark")} !important ;
  }
  li {
    list-style: none !important;
    font-weight: 600;
    border-radius: 10px;
    &:hover {
      cursor: pointer;
      color: ${({ theme }) => get(theme, "primary.dark")};
    }
  }
  .list-item {
    color: ${({ theme }) => get(theme, "secondary.dark")};
    padding: 7px 0;
    list-style: decimal;
    min-width: 160px;
    max-width: 220px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
    list-style-type: disc !important;
  }
`;

export const StyledSidebar = styled.div`
  margin-top: ${headerHeight};
  position: fixed;
  height: 100% !important;
  z-index: 9999;
  li {
    list-style: none !important;
  }
  .custom-menu {
    padding-right: 10px;
    padding-left: 10px;
    margin: 3px 0;
    .custom-menu-item {
      width: 98%;
      border-radius: 12px;
      padding: 12px;
      display: flex;
      /* justify-content: center; */
      align-items: center;
      display: flex;
      /* flex-direction: column; */
      /* text-align: center; */
      font-weight: 600;
      font-size: 13px;
      color: ${({ theme }) => get(theme, "secondary.dark")} !important;
      .icon {
        transform: scale(1.15);
        margin-bottom: 3px;
        /* svg path {
          fill: ${({ theme }) => get(theme, "secondary.dark")};
        } */
      }
      &:hover {
        color: ${({ theme }) => get(theme, "primary.dark")} !important;
        cursor: pointer;
        .icon {
          /* svg path {
            fill: ${({ theme }) => get(theme, "primary.dark")} !important;
          } */
          @keyframes tilt-shaking {
            0% {
              transform: scale(1.15) rotate(0deg);
            }
            25% {
              transform: scale(1.15) rotate(10deg);
            }
            50% {
              transform: scale(1.15) rotate(0eg);
            }
            75% {
              transform: scale(1.15) rotate(-10deg);
            }
            100% {
              transform: scale(1.15) rotate(0deg);
            }
          }
          animation: tilt-shaking 0.25s linear reverse;
        }
      }
    }
  }
  .custom-menu-item {
    width: 98%;
    border-radius: 12px;
    padding: 12px;
    display: flex;
    align-items: center;
    display: flex;
    font-weight: 600;
    font-size: 13px;
    .icon {
      transform: scale(1.15);
      margin-right: 15px;
      /* svg path {
        fill: ${({ theme }) => get(theme, "secondary.dark")};
      } */
    }
    color: ${({ theme }) => get(theme, "secondary.dark")} !important;
    &:hover {
      color: ${({ theme }) => get(theme, "primary.main")} !important;
      cursor: pointer;
      .icon {
        /* svg path {
          fill: ${({ theme }) => get(theme, "primary.dark")};
        } */
        @keyframes tilt-shaking {
          0% {
            transform: scale(1.15) rotate(0deg);
          }
          25% {
            transform: scale(1.15) rotate(10deg);
          }
          50% {
            transform: scale(1.15) rotate(0deg);
          }
          75% {
            transform: scale(1.15) rotate(-10deg);
          }
          100% {
            transform: scale(1.15) rotate(0deg);
          }
        }
        animation: tilt-shaking 0.25s linear reverse;
      }
    }

    &.openMenu ~ .list-item {
      color: red !important;
    }
  }

  .pro-sidebar-header {
    position: sticky;
    top: 0;
    z-index: 100000000000;
  }
  .pro-sidebar-content {
    position: relative !important;
    overflow-y: auto;
    background: ${({ theme }) => get(theme, "white.main")};
    transition: 0.2s all;

    &::-webkit-scrollbar {
      opacity: 0;
      position: absolute !important;
      z-index: 100000000 !important;
      right: 0 !important;
      width: 5px !important;
      cursor: pointer;
    }
    &::-webkit-scrollbar-track {
      transition: all 0.3s;
      background: ${({ theme }) => get(theme, "white.main")};
    }
    &:hover::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => get(theme, "primary.dark")};
    }
    &::-webkit-scrollbar-thumb {
      background: transparent;
      border-radius: 10px !important;
      &:hover {
        cursor: pointer !important;
      }
    }
  }
  & .pro-sidebar > .pro-sidebar-inner {
    background: white;
  }
  &
    .pro-sidebar
    .pro-menu.shaped
    .pro-menu-item
    .pro-inner-item
    .pro-icon-wrapper {
    background: white;
  }
  &
    .pro-sidebar
    .pro-menu
    > ul
    > .pro-sub-menu
    > .pro-inner-list-item
    .pro-inner-item:hover {
    color: ${({ theme }) => get(theme, "primary.dark")};
    background: transparent;
  }
  & .pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
    padding-left: 3rem;
    background: white;
  }
  & .pro-sidebar .pro-menu .pro-menu-item.active {
    color: ${({ theme }) => get(theme, "primary.dark")} !important;
    background-color: transparent;
  }

  & .pro-sidebar .pro-menu .pro-menu-item.menu-item-active {
    background: ${({ theme }) => get(theme, "white.light")};
    color: ${({ theme }) => get(theme, "primary.main")};
    border-radius: 12px;
    margin: 0 5px;
  }
  .openMenu.custom-menu-item {
    background-color: ${({ theme }) => get(theme, "white.light")};
    * {
      color: ${({ theme }) => get(theme, "primary.dark")} !important;
    }

    border-radius: 12px;
    svg path {
      /* fill: ${({ theme }) => get(theme, "primary.dark")} !important; */
    }
  }

  & .pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:focus {
    color: ${({ theme }) => get(theme, "primary.dark")};
  }
  & .pro-sidebar .pro-menu.shaped .pro-menu-item .pro-inner-item {
    margin: 0 5px;
  }
  & .pro-sidebar .pro-menu.shaped .openMenu > .pro-inner-item {
    background: ${({ theme }) => get(theme, "white.light")};
    color: ${({ theme }) => get(theme, "primary.dark")};
    border-radius: 12px;
  }
  & .pro-sidebar .pro-menu.shaped .pro-menu-item .pro-inner-item:hover {
    background: ${({ theme }) => get(theme, "white.light")};
    color: ${({ theme }) => get(theme, "primary.dark")};
    border-radius: 12px;
  }
  .pro-sidebar
    .pro-menu
    .pro-menu-item.pro-sub-menu
    > .pro-inner-item:hover
    > .pro-arrow-wrapper {
    .pro-arrow {
      color: red;
    }
  }
  .pro-sidebar .pro-menu .pro-menu-item.focus {
    color: black;
  }

  & .pro-sidebar .pro-menu.shaped .openMenu .pro-inner-item .pro-icon svg path {
    /* svg path {
      fill: ${({ theme }) => get(theme, "primary.dark")};
    } */
  }
  &
    .pro-sidebar
    .pro-menu.shaped
    .pro-menu-item
    .pro-inner-item:hover
    .pro-icon
    svg
    path {
    /* fill: ${({ theme }) => get(theme, "primary.dark")}; */
  }
  & .pro-sidebar .pro-menu.shaped .openMenu .pro-inner-item .pro-icon {
    background: ${({ theme }) => get(theme, "white.light")};
    color: ${({ theme }) => get(theme, "primary.dark")};
  }
  &
    .pro-sidebar
    .pro-menu.shaped
    .pro-menu-item
    .pro-inner-item:hover
    .pro-icon {
    background: ${({ theme }) => get(theme, "white.light")};
    color: ${({ theme }) => get(theme, "primary.dark")};
  }
  &
    .pro-sidebar.collapsed
    .pro-menu
    > ul
    > .pro-menu-item.pro-sub-menu
    > .pro-inner-list-item
    > .popper-inner {
    background: white;
  }
  .collapsed
    .pro-sidebar-inner
    .pro-sidebar-layout
    .pro-sidebar-content
    .pro-menu
    ul
    .pro-sub-menu
    .pro-inner-list-item
    .popper-inner {
    margin-left: 15px !important;
    z-index: 99;
  }
  .collapsed
    .pro-sidebar-inner
    .pro-sidebar-layout
    .pro-sidebar-content
    .pro-menu
    ul
    .pro-sub-menu
    .pro-inner-item {
    margin-left: 11px !important;
    padding-left: 13px !important;
  }
  .collapsed
    .pro-sidebar-inner
    .pro-sidebar-layout
    .pro-sidebar-content
    .pro-menu
    ul
    .pro-sub-menu:hover {
    .pro-inner-item {
      background: ${({ theme }) => get(theme, "white.light")} !important;

      border-radius: 12px;
      .pro-icon-wrapper {
        background: ${({ theme }) => get(theme, "white.light")} !important;

        .pro-icon {
          /* svg {
            path {
              fill: ${({ theme }) => get(theme, "primary.dark")} !important;
            }
          } */
        }
      }
    }
    .pro-inner-list-item {
      .pro-inner-item {
        background: transparent !important;
        border-radius: 0 !important;
      }
    }
  }
  .pro-menu {
    background-color: ${({ theme }) => get(theme, "white.main")};
  }
`;

export const StyledFooterLink = styled("a")`
  cursor: pointer;
  color: ${({ theme }) => get(theme, "white.dark")};
  text-decoration: none;
  transition: all 0.2s linear;
`;
